export interface FileResponse {
  blob: Blob;
  filename: string;
}

export function parseContentDispositionFilename(disposition: string | null): string {
  if (!disposition) return "";

  // RFC 5987 (filename*=UTF-8''...) идет первым: ASCII-filename рядом с ним —
  // это намеренный фолбэк для старых клиентов, а не настоящее имя файла.
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim());
    } catch {
      return encoded.trim();
    }
  }

  return disposition.match(/filename="(.+?)"/)?.[1] || "";
}

export async function fileResponseHandler(response: Response): Promise<FileResponse> {
  const filename = parseContentDispositionFilename(response.headers.get("Content-Disposition"));
  const blob = await response.blob();
  return { blob, filename };
}
